
export const guid = () => {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

export const setSession = (key, value) => {
    sessionStorage.setItem(key, value);
}

export const removeFromSession = (key) => {
    sessionStorage.removeItem(key);
}

export const getItemFromSession = (key) => {
    return sessionStorage.getItem(key);
}

export const sanitizePhone=(phone)=>{
    const phone_number=phone.replace(/[^\d\+]/g,"")
    return phone_number
}